export const SERVICE_CENTER_TAB_OPTIONS = [
  {
    name: '공지사항',
    value: 'notice',
    tab: 'notice',
    pathName: '/service-center/notice',
  },
  {
    name: '1:1 문의',
    value: 'QnA',
    tab: 'QnA',
    pathName: '/service-center/qna',
  },
  {
    name: '자주 묻는 질문',
    value: 'FAQ',
    tab: 'FAQ',
    pathName: '/service-center/faq',
  },
];

export const INQUIRY_TYPES = [
  { value: '', label: '문의 유형을 선택해 주세요', disabled: true },
  { value: 'INQ100', label: '가입/탈퇴 문의', disabled: false },
  { value: 'INQ200', label: '판매몰 연동 문의', disabled: false },
  { value: 'INQ300', label: '판매예정금 데이터 문의', disabled: false },
  { value: 'INQ400', label: '대출 문의', disabled: false },
  { value: 'INQ500', label: '기타 문의', disabled: false },
];
